import React from 'react';

const fmtDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

/**
 * MrpEffectiveDate — small label shown next to the current MRP once a
 * Price Master deploy has set `mrp_deployed_at`. Stays visible until
 * the next deploy (no time cooldown — replaced by next deploy's date).
 *
 * The old red/green "MRP INCREASED +X%" badge was removed on
 * 2026-05-30 per operator request; only the new MRP + effective date
 * are shown going forward.
 */
export const MrpEffectiveDate = ({ part, className = '' }) => {
  const at = part?.mrp_deployed_at;
  if (!at) return null;
  const str = fmtDate(at);
  if (!str) return null;
  return (
    <span
      className={`text-[10px] text-gray-500 italic ${className}`}
      title={`Effective from ${str}`}
      data-testid={`mrp-effective-${part.jp_part_no}`}
    >
      Effective from {str}
    </span>
  );
};

// Default export kept as `null` to short-circuit any stale imports
// (`import X from '...'`) and force a clean refactor on the caller side
// instead of rendering an orphan badge.
export default null;
